import { Layout } from "components2";
import { AlertPanel, ALink, Disclaimer2, NextButton, NextButton2 } from "components2/CommonUI";
import { useEffect, useState } from "react";
import { useLocation, useNavigate,
  useParams } from "react-router-dom";
import { O2APPOINTMENT_ENTRY, O2APPOINTMENT_INFO, O2FORM, O2IDENTITY } from "../constants/route";
import { useSelector, useDispatch, batch } from "react-redux";
import {
  updateAck,
  updateMid,
  updateSid,
  clear,
  nextIdentity,
  updateHasAppt
} from "../redux/o2Appointment";
import { hasAppointment } from "services/api-service2";
import { ID_TYPE } from "constants/o2Appointment";
import { has } from "lodash";
import { useAdobeDigitalData, useWogaa } from "hooks";

const from = { state : {from: O2FORM}};

// May or may not come from third party link
// Refresh will not lost the third party refer main id and sub id
// This form page will not auto route to any other page based on workflow.
// Workflow logic routing will only happen when click next.
// Three possible next points are;
// 1. O2AppointmentInfo
// 2. O2AppointmentEntry
// 3. O2Identity
export default function O2FormPage() {
  const [accepted, setAccepted] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const { isLogin } = useSelector((state) => state.signPassIdentify);
  const { nric } = useSelector((state) => state.appointment);
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  //const { startComplete } = useWogaa();
  useAdobeDigitalData({name: "FORM", path:"/form"});

  useEffect(() => {
    dispatch(clear());
  }, []);

  // update mid and sid from url
  useEffect(() => {
    const { mid, sid } = params;
    if (mid) {
      dispatch(updateMid(parseInt(mid, 10)));
    } else {
      // This may need to off if we want to retain values after back from next steps
      dispatch(updateMid(null));
    } 
    if (sid) {
      dispatch(updateSid(parseInt(sid, 10)));
    } else {
      // This may need to off if we want to retain values after back from next steps
      dispatch(updateSid(null));
    }
  }, [params]);

  const clkNext = async () => {
    setLoading(true);
    if(loading) return;
    
    dispatch(updateAck(true));
    //startComplete();
    if (isLogin) {
      const hasAppt = await hasAppointment(nric);
      if (hasAppt) {
        navigate(O2APPOINTMENT_INFO, from);
      } else {
        // Skip identity page and pre fill
        dispatch(nextIdentity({ idType: ID_TYPE.NRIC_FIN, nricFin: nric, passport: null }));
        navigate(O2APPOINTMENT_ENTRY, from);
      }
    } else {
      navigate(O2IDENTITY, from);
    }
  };

  const h4Style = {fontSize: 24, fontWeight:600, margin: 0, lineHeight: '32px', letterSpacing: -0.5}

  return (
    <Layout
      subHeader={"Book an appointment"}
      mainText={
        // style copied: https://www.cpf.gov.sg/member/tools-and-services/calculators/cpf-housing-usage
        <div className={"section-header col-md-10 col-sm-10"}>
          <div className="title-container">
            <div className="title__text--overline  fs--default">CONTACT US</div>
            <h2 className="title__text title__text--semi-bold">Book an appointment</h2>
          </div>
        </div>
      }>
      <h1 className="sr-only">Customer Service Appointment Booking</h1>
      <main id="appointment-form">
        <div className="form-box--plain">
          <div className={"px-md-3 py-md-2"}>
            <div className={"row p-3"} style={{alignItems:"flex-start"}}>
              <div className={"col-md-7 sm-mb-16"} style={{backgroundColor:"#fff"}}>
                <p className={"mb-4 semi-bold"} style={h4Style}>
                  Book an appointment to speak with our customer service officer.
                </p>
                <p>
                  You can make bookings for another person under their NRIC, FIN or passport number.
                  Make sure you are logged out first, as you cannot enter another person’s ID while
                  logged in with Singpass.
                </p>
                <p>
                  Likewise, to change or view a booking you made for another person, please log out
                  before proceeding. Bookings can only be viewed under the customer’s own NRIC, FIN or
                  passport number.
                </p>
                {/*<p>
                  For customers leaving Singapore with no plan to return to live or work, we recommend that they close their CPF accounts before they leave.
                  If you need to close your account from overseas, submit the form&nbsp;
                  <ALink><u>CPF account closure for non-Singapore Citizens and Permanent Residents</u></ALink>
                   with supporting
                  documents verified by a&nbsp;
                  <ALink><u>
                  Singapore Overseas Mission
                    </u></ALink>
                  .
                </p>*/}
                {/*<ul className={"bullet--disc bullet--space"}>
                  <li>
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ducimus, repudiandae.
                  </li>
                  <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto, unde?</li>
                  <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Atque, nobis.</li>
                  <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Illo, iusto.</li>
                </ul>*/}
              </div>
              <div className="col-md-5 instructions instructions-mod">
                <div className="instructions-content">
                  <h5 className={"sm-mb-16 md-mb-16"}>To complete the form, you will need:</h5>
                  <ul className={"bullet--space"}>
                    <li>An NRIC, FIN, or passport number.</li>
                    <li>
                      An email address or Singapore-registered mobile number for OTP authentication
                      and reminders.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="form-footer">
            {/*<div className={"flex--space-between"}>*/}
            <div
              className={
                "w-100 d-flex flex-column flex-md-row justify-content-between px-md-3 py-2 align-items-start "
              }>
              <Disclaimer2
                text={"I have read and accepted the"}
                linkText={"Terms of Use"}
                onChange={() => setAccepted(!accepted)}
                checked={accepted}
                className=" sm-mb-16"
              />

              <NextButton2 text={"Start"} disabled={!accepted} onClick={clkNext} />
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
}
